import React, { useState, useEffect } from "react";
import banner from "../../../assets/images/banner.jpg";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import './banner.css'

export const Banner = ({ executeScroll }) => {
  //background
  const [offsetY, setOffsetY] = useState(window.pageYOffset);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div id="background" className="Banner">
      <div className="Banner_ImageBox">
        <img
          src={banner}
          className="Banner_ImageBox_Image"
          alt="banner_image"
          style={{ transform: `translateY(${offsetY * 0.5}px)` }}
        />
      </div>

      <div
        className="Banner_TextBox Container"
        style={{ transform: `translateY(${offsetY * 0.7}px)` }}
      >
        Junior Developer
        <div className="Banner_TextBox_SubText">
          <div>Ayron Vanhee</div>

          <div
            onClick={executeScroll}
            className="Banner_TextBox_SubText_ContactButton"
          >
            Contacteer
          </div>
        </div>
      </div>
      <div className="Banner_ArrowBox">
        <FontAwesomeIcon icon={faChevronDown} 
        className="Banner_ArrowBox_Image"
        style={{ transform: `translateY(${offsetY * 0.5}px)` }}
        />
      </div>
    </div>
  );
};
